import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { MomentModule } from 'angular2-moment';
import { NgSlimScrollModule } from "../../../node_modules/ngx-slimscroll/src/ngx-slimscroll/module/ngx-slimscroll.module";
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

// Common Features Module
import { BrightServeCommonModule } from 'app/common/brightserve-common.module';

import { BrightServeModule } from "app/brightserve/brightserve.module";
import { AuthGuard } from "app/brightserve/auth-guard";
import { SharedModule } from "app/shared/shared.module";
import { AddonModule } from "app/add-ons/addon.module";

import { PersonDetailsComponent } from './details/person-details.component';
import { ArchivedCasesComponent } from './details/archived-cases/archived-cases.component';
import { GeneralInformationComponent } from './details/general/general-information.component';
import { PersonService } from "app/person/person.service";

const PersonRoutes: Routes = [
	{ path: 'person/:id', component: PersonDetailsComponent, children: [
			{ path: '', redirectTo: 'general', pathMatch: 'full' },
			{ path: 'general', component: GeneralInformationComponent },
			{ path: 'archived-cases', component: ArchivedCasesComponent },
        ], canActivate: [AuthGuard] }
];

@NgModule({
	imports: [
		CommonModule,
        FormsModule,
        MomentModule,
        NgSlimScrollModule,
        InfiniteScrollModule,
		RouterModule.forChild(PersonRoutes),
        BrightServeCommonModule,
		BrightServeModule,
		SharedModule,
        AddonModule,
	],
    declarations: [PersonDetailsComponent, ArchivedCasesComponent, GeneralInformationComponent],
    providers: [PersonService]
})

export class PersonModule { }



// WEBPACK FOOTER //
// ./src/app/person/person.module.ts